import React, { ReactElement, useState } from "react"
import { colors, fonts, glyphs } from "../../Styles"
import { useTranslation } from "react-i18next"
import { Button, ButtonList, NewInput } from "."
import { ButtonTypes, NewFieldStyles } from "../../Definitions"

interface Widget_Props {
  header?: string
  leftContent?: ReactElement
  rightContent?: ReactElement
  editMode?: {
    editHeader?: boolean
    editLeftContent?: ReactElement
    editRightContent?: ReactElement
  }
  verticalContent?: boolean
  onSave?:() => void
}
/**
 * Widget
 * @param header elements for header-area goes here.
 * @param content elements for content-area goes here.
 * @param onSave functionality on "save btn". 
 * @returns a basic frame for widgets
 */
export default function EnhancedWidget({header, verticalContent, leftContent, rightContent, editMode, onSave}:Widget_Props) {
  const {t} = useTranslation()
  const [isEditing, setIsEditing] = useState(false)

  const handleSaveClick = () => {
    setIsEditing(!isEditing)
    if (onSave) onSave()
  }

  const handleCancelClick = () => {
    setIsEditing(!isEditing)
  }

  const handleEditClick = () => {
    setIsEditing(!isEditing)
  }

  // #region | Buttons
  const buttons =
      // <div style={{margin: "0px 20px 0px 0px"}}>
      <div style={{}}>
        { !isEditing 
          ? <Button content={t("buttons.edit", {defaultValue: "edit"})} startEnhancer={glyphs.Edit({fillColor: colors.greyLightTertiary})} buttonType={ButtonTypes.tableButton} onClick={handleEditClick}/>
          : <ButtonList 
              contents={[t("buttons.save", {defaultValue: "save"}), t("buttons.cancel", {defaultValue: "cancel"}), t("buttons.edit", {defaultValue: "edit"})]}
              onClick={(i => {
                if (i === 0) {handleSaveClick()}
                else if (i === 1) {handleCancelClick()}
              })}
              buttonType={ButtonTypes.tableButton}
              disabled={[false, false, true]}
              overrides={(index) => ({
                baseButton: {
                  backgroundColor: index === 2 ? colors.greyPrimary : colors.greySecondary
                },
                disabledStyles: {
                  opacity: index === 2 ? 1 : 0.5
                }
              })}
              startEnhancers={[glyphs.Check({fillColor: colors.greyLightTertiary}), glyphs.Close({fillColor: colors.greyLightTertiary}), glyphs.Edit({fillColor: colors.greyLightTertiary})]}
            />
        }   
      </div>
    // #endregion

  return (
    <div style={{boxSizing: "border-box", display: "flex", minHeight: verticalContent ? "500px" : "300px", height: "fit-content", width: "100%", maxWidth: verticalContent ? "410px" : "700px", flexDirection: "column"}}>
      
      <div style={{boxSizing: "border-box", display: "grid", gridTemplateColumns: isEditing&&verticalContent&&editMode?.editHeader ? "1fr" : "repeat(2, 1fr)", gridTemplateRows: isEditing&&verticalContent&&editMode?.editHeader ? "repeat(2, 1fr)" : "1fr"}}>
          <div style={{margin: isEditing&&verticalContent&&editMode?.editHeader ? "0px" : "0px 0px 0px 20px", gridArea: "1/1/2/2", display: "flex", alignItems: "center", justifyContent: "start", borderTop: isEditing&&verticalContent&&!editMode?.editHeader ? "" : "5px solid "+colors.greyPrimary}}>
            {isEditing&&editMode?.editHeader ? (
              <NewInput
                isClearable
                isRequired
                fieldOverrides={{
                  fieldStyle: NewFieldStyles.transparent,
                  fieldWidth: "100%"
                }}
                valueOverrides={{
                  defaultValue: header
                }}
              />
            ) : isEditing&&verticalContent&&!editMode?.editHeader ? 
            ( <></> ) : (
              <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", paddingLeft: "5px" }}>{header}</p>
            )}
          </div>
          <div style={{margin: "0px 20px 0px 0px", gridArea: isEditing&&verticalContent&&editMode?.editHeader ? "2/1/3/2" : "1/2/2/3", display: "flex", justifyContent: "end"}}>
            {buttons}
          </div>
      </div>

      <div style={{ borderRadius: "10px", display: "grid", gridTemplateColumns: verticalContent ? "1fr" : "330px 1fr", gridTemplateRows: verticalContent ? "240px 1fr" : "1fr", border: "5px solid "+colors.greyPrimary, height: "100%", boxSizing: "border-box", overflowY: "hidden", width: "100%", backgroundColor: colors.greyLightTertiary}}>
        <div style={{ boxSizing: "border-box", gridArea: "1/1/2/2", height: "100%", overflow: "hidden" }}>
          {isEditing ? (
            <>{editMode?.editLeftContent}</>
          ) : (
            <>{leftContent}</>
          )}
        </div>
        
        <div style={{boxSizing: "border-box", gridArea: verticalContent ? "2/1/3/2" : "1/2/2/3", overflowY: "hidden", width: "100%", backgroundColor: colors.greyPrimary}}>
          {isEditing ? (
            <>{editMode?.editRightContent}</>
          ) : (
            <>{rightContent}</>
          )}
        </div>

      </div>
    </div>
    // </div>
  )
}